import { useQuery } from 'common/hooks';
import { getReporteesObjectivesApi } from '../objectives.service';
import { ObjectiveResponse } from '../types/objective.type';

export const useGetReporteeObjectives = (enabled = true) => {
  const queryResponse = useQuery(['reportee-objectives'], getReporteesObjectivesApi, {
    enabled,
    select: (response) => ({
      ...response,
      data: response.data.objectives as ObjectiveResponse[],
    }),
  });

  return {
    ...queryResponse,
    data: queryResponse?.data?.data,
  };
};
